import { formForbidden } from "../../../services/data/form"
import { readProjectRoleCode, readRoleCode } from "../../../utils/storage"

// 君实外呼特殊表单
const CALL_CENTER_FORM_CODE = 'FMJSNSCLC01CR03'
// 外呼角色
const CALL_CENTER_ROLE_CODE = 'CALL_CENTER'

/**
 * 判断当前用户是否是只读权限
 * @param formCode 
 * @returns 
 */
export const isReadOnly = (formCode: string): boolean => {
  if (readProjectRoleCode() === 'ReadOnly') {
    return true
  }
  const roleCode = readRoleCode()
  if (roleCode === 'EDC_READ') {
    return true
  }
  // 外呼角色
  if (roleCode === CALL_CENTER_ROLE_CODE) {
    // Call Center 以外的表单禁用
    return formCode !== CALL_CENTER_FORM_CODE
  }
  // 其他角色 Call Center 表单禁用
  return formCode === CALL_CENTER_FORM_CODE
}

type Mapping = {
  [key: string]: number
}

// !!!君实 - 表单锁定特殊处理
export class JSFormLock {
  
  // 表单中是否有list类型的字段
  private static hasListField(bodyData: any) {
    for(const t of bodyData) {
        if (t.type === 'list') {
            return true
        }
        if (Array.isArray(t.children)) {
            if (JSFormLock.hasListField(t.children)) {
                return true
            }
        }
    }
    return false
  } // hasListField

  // 将list字段类型从body中挑出来
  private static pickListKeys(listed: boolean, flag: number, body: any) {
    const keys: string[][] = []
    //
    const pick = (listed: boolean, flag: number, body: any)=> {
      body.forEach((t: any)=> {
        if (t.type === 'list') {
          pick(true, flag+1, t.children)
        } else if (Array.isArray(t.children)) {
          pick(listed, flag, t.children)
        } else {
          if (listed) {
            if (Array.isArray(keys[flag])) {
              keys[flag].push(t.dataCode)
            } else {
              keys[flag] = [t.dataCode]
            }
          }
        }
      })
    }

    pick(listed, flag, body)

    return keys
  } // pickListKeys

  // 从已保存的数据中分离出表单最大索引
  private static resolveMaxIndex(values: any) {
    const mapping: {[key: string]: number} = {}
    values.forEach((t: any)=> {
      if (t.dataCode.indexOf('#') > -1) {
        const [dataCode, index] = t.dataCode.split('#')
        if (typeof mapping[dataCode] === 'number') {
          if (mapping[dataCode] < Number(index)) {
            mapping[dataCode] = Number(index)
          }
        } else {
          mapping[dataCode] = Number(index)
        }
      }
    })
    return mapping
  } // resolveMaxIndex

  // 标记list最大索引
  private static resolveValues(keys: string[][], mapping: Mapping) {
    const values: number[] = []
    keys.forEach((a: string[])=> {
      let max = 0
      a.forEach((dataCode: string)=> {
        if (typeof mapping[dataCode] === 'number') {
          if (max < mapping[dataCode]) {
            max = mapping[dataCode]
          }
        }
      })
      values.push(max)
    })
    return values
  } // resolveValues

  // 遍历body 将已提交的字段锁定
  private static takeFields(keys: string[][], values: number[], listed: boolean, body: any) {
    const fields: string[] = []
    
    const take = (listed: boolean, body: any)=> {
      body.forEach((item: any)=> {
        if (Array.isArray(item.children)) {
          take(listed ? listed : item.type === 'list', item.children)
        } else {
          // list字段
          if (listed) {
            // 获得最大
            const maxIndex = keys.findIndex(s=> s.includes(item.dataCode))
            const max = values[maxIndex]
            for(let i=1; i<=max; i++) {
              fields.push(`${item.dataCode}#${i}`)
            }
          } else {
            fields.push(item.dataCode)
          }
        }
      })
    }

    take(false, body)

    return fields
  } // takeFields

  // 君实 - 表单锁定特殊处理
  static async handle(workbench: boolean, formId: number, data: any) {

    if (!Array.isArray(data.body)) {
      return
    }

    // 优先JSON配置
    // if (typeof data.body[0].ro === 'object') {
    //   return
    // }

    // 表单是否有list类型字段
    const appendAction = this.hasListField(data.body)

    // 移除DataActionUpdate
    const i = data.dataActions.findIndex((a: string)=> a === 'DataActionUpdate')
    if (i > -1) {
      data.dataActions.splice(i, 1)
    }

    // 表单锁定时使用通用锁表逻辑
    if (data.lockState === 'Complete') {
      // 当表单不存在list类型的字段时不需要特别操作使用默认禁用
      if (appendAction) {
        // 挑出所有list中的dataCode
        const keys = this.pickListKeys(false, -1, data.body)

        // 从已提交表单数据中分离出表单最大索引
        const mapping = this.resolveMaxIndex(data.values)

        // 标记list最大索引
        const values = this.resolveValues(keys, mapping)

        // 遍历body 将已提交的字段锁定
        const fields = this.takeFields(keys, values, false, data.body)

        // 表单中没有list类型的字段时全部禁用
        data.body.forEach((t: any)=> {
          const partial = t.ro || {}
          t.ro = {
            ...partial,
            fields: [fields],
            lost_control_add: true
          }
        })
      } else {
        // 表单中没有list类型的字段时全部禁用
        data.body.forEach((t: any)=> {
          if (typeof t.ro === 'undefined') {
            t.ro = true
          }
        })
      }
    }
    // 从工作台入口 - 辅助治疗期和新辅助治疗期特瑞普利单抗给药记录表单
    else if (workbench && ['FMJSNSCLC01RTR02', 'FMJSNSCLC01RTR04'].includes(data.formCode)) {
      // 动态获取当前表单是否需要禁用
      const r = await formForbidden(formId)
      if (r.code === 0 && r.data.length > 0) {
        data.body.forEach((t: any)=> {
          t.ro = {
            fields: [r.data, []],
            lost_control_add: true
          }
        })
      }
    }

    // 保留全量提交模式
    if (appendAction || data.lockState === 'Wait') {
      // 强制显示【提交】按钮
      if (!data.formActions.includes('FormActionSubmit')) {
          data.formActions.push('FormActionSubmit')
      }
      // 强制修改为编辑模式
      if (!data.dataActions.includes('DataActionInput')) {
          data.dataActions.push('DataActionInput')
      }
    }
  } // handle

  // 君实 - 表单锁定特殊处理
  static async handlefast(workbench: boolean, formId: number, data: any) {

    if (!Array.isArray(data.body)) {
      return
    }

    // 优先JSON配置
    // if (typeof data.body[0].ro === 'object') {
    //   return
    // }

    // 表单是否有list类型字段
    const appendAction = this.hasListField(data.body)

    // 移除DataActionUpdate
    const i = data.dataActions.findIndex((a: string)=> a === 'DataActionUpdate')
    if (i > -1) {
      data.dataActions.splice(i, 1)
    }

    // 表单锁定时使用通用锁表逻辑
    if (data.lockState === 'Complete') {
      // 当表单不存在list类型的字段时不需要特别操作使用默认禁用
      if (appendAction) {

        // 遍历body 将已提交的字段锁定
        const fields = data.values.map((t: any)=> t.dataCode)

        // 表单中有list类型的字段时全部禁用
        data.body.forEach((t: any)=> {
          const partial = t.ro || {}
          t.ro = {
            ...partial,
            fields: [fields],
            lost_control_add: true,
            lost_control_del: true,
          }
        })
      } else {
        // 表单中没有list类型的字段时全部禁用
        data.body.forEach((t: any)=> {
          if (typeof t.ro === 'undefined') {
            t.ro = true
          }
        })
      }
    }
    // 从工作台入口 - 辅助治疗期和新辅助治疗期特瑞普利单抗给药记录表单
    else if (workbench && ['FMJSNSCLC01RTR02', 'FMJSNSCLC01RTR04'].includes(data.formCode)) {
      // 动态获取当前表单是否需要禁用
      const r = await formForbidden(formId)
      if (r.code === 0 && r.data.length > 0) {
        data.body.forEach((t: any)=> {
          t.ro = {
            fields: [r.data, []],
            lost_control_add: true,
            lost_control_del: true,
          }
        })
      }
    }

    // 保留全量提交模式
    if (appendAction || data.lockState === 'Wait') {
      // 强制显示【提交】按钮
      if (!data.formActions.includes('FormActionSubmit')) {
          data.formActions.push('FormActionSubmit')
      }
      // 强制修改为编辑模式
      if (!data.dataActions.includes('DataActionInput')) {
          data.dataActions.push('DataActionInput')
      }
    }
  } // handlefast

  // 清理所有ro数据中的字段
  static handleclean(fields: string[], body: any) {
    //
    const clear = (fields: string[], target: any)=> {
      target.forEach((t: any)=> {
        if (t.ro && Array.isArray(t.ro.fields)) {

          // 清理
          const ff = t.ro.fields[0] || []
          for(const d of fields) {
            const i = ff.indexOf(d)
            if (i > -1) {
              ff.splice(i, 1)
            }
          }

          if (Array.isArray(t.children)) {
            clear(fields, t.children)
          }
        }
      })
    }

    clear(fields, body)
  }
}
